/** saves List of Associated Customers
@payload { array } - no documentation
*/
export const SAVE_ASSOCIATED_CUSTOMERS = (state, payload) => {
    state.associatedCustomersList = payload
}
